// extracted by mini-css-extract-plugin
export default {"container":"NotificationPopUp_container__UamZx","closeBtn":"NotificationPopUp_closeBtn__WIFHn"};